export default __webpack_public_path__ + "static/media/8.04ef2fb0.jpg";